import axios from 'axios';

import type {
  GetSerialNumbersForUserResponse,
  JsonObject,
} from '@/app-package';

export type SerialNumbersForUser = JsonObject<GetSerialNumbersForUserResponse>;

const getSerialNumbersForUser = async (userId: string, brand: string) => {
  const { data } = await axios.get<SerialNumbersForUser>(
    `/lockbox/serial_numbers/${userId}/${brand}`,
  );

  return data;
};

export default getSerialNumbersForUser;
